import { Directive, Input } from '@angular/core';
import { EconomyHistoryComparison } from './economy-history.service';

@Directive()
export class BaseRow {

  @Input() entry: EconomyHistoryComparison;
  @Input() index: number;
}
